<style scoped lang="less">
  .protocol{
    position: relative;
  }
  .pro-container {
    width: 1200px;
    margin: 0 auto;
    width: 100%;
    padding: 100px 0 100px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    position: relative;
  }
  .pro-title {
    //padding-left: 30px;
    width: 121px;
    //height: 29px;
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
    line-height: 60px;
    margin-bottom: 20px;
  }
  .pro-text {
    //text-indent: 30px;
    //padding-left: 30px;
    //margin-top: 10px;
    width: 411px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    //line-height: 27px;
  }
  .pro-button {
    //margin-left: 50px;
    text-align: center;
    line-height: 50px;
    border: 0;
    outline: none;
    cursor: pointer;
    width: 190px;
    height: 50px;
    font-size: 18px;
    background-color: #2368dd;
    color: white;
    margin-top: 30px;
  }

  .pro-image {
    margin-left: 10%;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 437px;
    height: 332px;
    background-image: url('http://cdn-cus.weixinhai.net/cdn/web/img/house-first.d1412960.png');
    background-size: 100% 100%;
  }

  .pro-img-s {
    z-index: 1000;
    position: absolute;
    left: 150px;
    top: -60px;
    //margin-right:120px;
    width: 527px;
    height: 447px;
  }
  .pro-content {
    padding-right: 20px;
    a {
      text-decoration: none
    }
  }

  @media(max-width: 1200px) {
    .pro-container{
      width: 100%;
    }
  }
  @media(max-width: 480px) {
    .pro-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      margin: 0 auto;
      padding: 0 0 60px 0;
    }

    .pro-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .pro-title {
      text-align: center;
      font-size: 28px;
      width: 100%;
      margin: 30px auto;
    }
    .pro-text {
      padding-top: 10px;
      width: 100%;
      margin: 0 auto;
      margin-left: 20px;
      margin-right: 20px;
    }
    .pro-content {
      padding-left: 20px;
      padding-right: 20px;
    }
    .pro-button {
      margin-top: 30px;
    }
    .pro-image {
      margin-left: 20px;
      width: 237px;
      height: 132px;
      margin-top: 50px;
    }
    .pro-img-s {
     position: absolute;
      left: 50px;
      top: -30px;
      width: 227px;
      height: 207px;
      margin-right: 20px;
    }
  }
</style>
<template>
  <div class="protocol" id="whyId" >
    <div class="pro-container">
      <div class="pro-content">
        <p :class="['pro-title', {'animated fadeInUp': flag}]">{{$t('Protocol.title.a')}}</p>
        <p :class="['pro-text', {'animated fadeInUp': flag}]">{{$t('Protocol.title.b')}}</p>
<!--        <p :class="['pro-text', {'animated fadeInUp': flag}]">{{$t('Protocol.title.d')}}</p>-->
        <a href="AboutUs.html"><p :class="['pro-button', {'animated fadeInUp': flag}]">{{$t('Protocol.title.c')}}</p></a>
      </div>
      <div>
        <div class="pro-image">
          <img class="pro-img-s" src="http://cdn-cus.weixinhai.net/cdn/web/img/house-second.bbfd1a5c.png"/>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Protocol.vue',
  data () {
    return {
      flag: true,
      interTimer: null
    }
  },
  mounted () {
  },
  destroyed () {
  }
}
</script>
